"use client"

import type { SmartAnalysisDirection } from '@yeshuman/sdk'
import type { SearchResultsSummary } from './search-progress-card'

export type SearchProgressCollapsedSummaryProps = {
  direction: SmartAnalysisDirection
  resultsSummary?: SearchResultsSummary | null
}

export function SearchProgressCollapsedSummary({
  direction,
  resultsSummary,
}: SearchProgressCollapsedSummaryProps) {
  const evaluated = resultsSummary?.total_candidates_evaluated
  const matchNoun = direction === 'opportunities' ? 'jobs' : 'candidates'

  return (
    <p className="text-sm text-muted-foreground">
      Last run found no matching {matchNoun}
      {evaluated != null && evaluated > 0 ? ` · ${evaluated} evaluated` : ''}
    </p>
  )
}
